import { jsx } from 'react/jsx-runtime';
import style from './ProgressBar.module.css.js';

const ProgressBar = ({ percentage, width }) => {
    const pct = Math.min(Math.max(percentage, 0), 1) * (width || 120);
    return (jsx("div", { className: style.bgBar, style: { ...(width && { width: width }) }, children: jsx("div", { className: style.progress, style: { width: `${pct}px` } }) }));
};
ProgressBar.displayName = "ProgressBar";

export { ProgressBar };
//# sourceMappingURL=ProgressBar.js.map
